import FormSelectInput from "./FormSelectInput";

export const getInitial = (value) => {
    const values = [
        { value: -8, label: 'Pacific Standard Time (UTC-8)' },
        { value: -7, label: 'Pacific Daylight Time (UTC-7)' },
        { value: -7, label: 'Mountain Standard Time (UTC-7)' },
        { value: -6, label: 'Mountain Daylight Time (UTC-6)' },
        { value: -6, label: 'Central Time (UTC-6)' },
    ];

    if (!value) return values;
    return values.find(v => v.value === value)
}

const FormSelectTimezone = (props) => {
    const loadOptions = async (input) => {
        return Promise.resolve(getInitial())
    }

    return (
        <FormSelectInput loadOptions={loadOptions} {...props} />
    )
}

export default FormSelectTimezone;